module.exports = __webpack_public_path__ + "assets/img/14_1562.9cbf5638.jpg";